import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "stages-board" }
const _hoisted_2 = { class: "stages-board__item" }
const _hoisted_3 = { class: "stages-board__item-header" }
const _hoisted_4 = { class: "stages-board__item-title" }
const _hoisted_5 = {
  key: 0,
  class: "stages-board__item-date"
}
const _hoisted_6 = { class: "title" }
const _hoisted_7 = { class: "team-card__user-info" }
const _hoisted_8 = {
  key: 0,
  class: "ml-auto team-card__request"
}

import { useProgramsStore } from '@/stores/programs';
import { computed, ref, watch } from 'vue';
import { useRouter } from 'vue-router';
import dayjs from 'dayjs'
import { useTrackersStore } from '@/stores/trackers';
import { useUiStore } from '@/stores/ui';
import TeamStatus from '@/components/TeamStatus.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'RoadMap',
  setup(__props) {

const router = useRouter()
const programsStore = useProgramsStore()
const trackersStore = useTrackersStore()

const program = computed(() => {
  const programId = router.currentRoute.value.params.programId
  return programsStore.programs.find(item => item.id === programId)
})

const uiStore = useUiStore()
const openTeam = (team: any) => {
  uiStore.team = team
}


return (_ctx: any,_cache: any) => {
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(programsStore).stages, (stage) => {
      return (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(stage.name), 1),
          (stage.deadline)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_unref(dayjs)(stage.deadline).format("D MMMM")), 1))
            : _createCommentVNode("", true)
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(program)?.teams.filter(item => item.programStageId === stage.id), (team) => {
          return (_openBlock(), _createBlock(_component_v_card, {
            class: "team-card",
            variant: "outlined",
            ripple: true,
            onClick: ($event: any) => (openTeam(team))
          }, {
            default: _withCtx(() => [
              _createVNode(TeamStatus, {
                "stage-id": team.programStageId,
                date: new Date().toISOString()
              }, null, 8, ["stage-id", "date"]),
              _createElementVNode("div", _hoisted_6, _toDisplayString(team.name), 1),
              _createVNode(_component_v_divider),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_v_avatar, {
                  size: 24,
                  image: _unref(trackersStore).trackers[team.trackerId]?.avatar,
                  color: "grey-lighten-1",
                  class: "mr-2"
                }, null, 8, ["image"]),
                _createElementVNode("div", null, _toDisplayString(_unref(trackersStore).trackers[team.trackerId]?.name), 1),
                (team.TrackerReport?.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createVNode(_component_v_icon, {
                        icon: "mdi-information-outline",
                        size: "small",
                        class: "mr-1"
                      }),
                      _createTextVNode("Запрос ")
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 2
          }, 1032, ["onClick"]))
        }), 256))
      ]))
    }), 256))
  ]))
}
}

})